<template>
  <div class="booked-bags">
    <div
      v-for="(traveler, traveler_index) in Object.keys(flexible_bags)"
      :key="`${_uid}:additional-bags:${traveler_index}`"
      :set="
        traveler_detail = traveler_detail_by_id(
          (flight_offer.travelerPricings[traveler] || {}).travelerId,
        )
      "
      class="booked-bags__item"
    >
      <traveler-label :traveler_info="traveler_detail" use_name />
      <div
        v-for="(itinerary, itinerary_index) in Object.keys(
          flexible_bags[traveler],
        )"
        :key="`${_uid}:additional-bags:${traveler_index}:${itinerary_index}`"
        :set="itd = flight_offer.itineraries[itinerary]"
        class="booked-bags__item-wrapper"
      >
        <div
          v-for="(bag, bag_index) in Object.keys(
            flexible_bags[traveler][itinerary],
          )"
          :key="`${_uid}:additional-bags:${traveler_index}:${itinerary_index}:${bag_index}`"
        >
          <template v-if="flexible_bags[traveler][itinerary][bag].added">
            <div
              class="booked-bags__item-bag"
              :set="bag = flexible_bags[traveler][itinerary][bag].bag"
            >
              <span>
                {{
                  bag.name ||
                  `${bag.quantity} ${bag.quantity !== 1 ? "bagagli" : "bagaglio"}`
                }}
              </span>
              <i>
                ({{ itd.firstDeparture.iataCode }}
                {{ itd.firstDeparture.airportName }}
                -
                {{ itd.lastArrival.iataCode }}
                {{ itd.lastArrival.airportName }})
              </i>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TravelerLabel from "@liveflight/components/blocks/traveler/traveler-label.vue";

export default {
  name: "booked-bags",
  components: {
    "traveler-label": TravelerLabel,
  },
  props: {
    flight_offer: {
      type: Object,
      required: true,
    },
    travelers: {
      type: Array,
      default: () => [],
    },
    flexible_bags: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    /**
     * Two callers pass different traveler shapes — the store's
     * `traveler_details` (lowercase firstname/lastname) and the Amadeus
     * order's `data.travelers` (name.firstName/lastName). Flatten both
     * so the template reads one field regardless of the source.
     */
    traveler_details() {
      return (this.travelers || []).map((entry) => {
        const { name = {} } = entry || {};
        return {
          ...entry,
          firstname: entry.firstname || name.firstName || name.firstname || "",
          lastname: entry.lastname || name.lastName || name.lastname || "",
        };
      });
    },
  },
  methods: {
    traveler_detail_by_id(traveler_id) {
      return (
        this.traveler_details.find((t) => t && t.id === traveler_id) || {}
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.booked-bags {
  margin-top: $grid-gutter-width / 2;

  &__item {
    &-bag {
      font-size: $font-size-md;
      margin-left: $grid-gutter-width / 9;
      margin-top: $grid-gutter-width / 8;
    }

    &:not(:first-child) {
      margin-top: $grid-gutter-width / 2;
    }
  }
}
</style>
